<template>
  <form @submit.prevent="handleSubmit">
    <l-columns>
      <l-columns-column size="3">
        <casino-select
          v-model="input.casinoId"
          :label="$t('common.casino')"
          :placeholder="$t('common.all')"
          name="casinoId"
        />
      </l-columns-column>
      <m-input
        v-model="input.playerId"
        name="playerId"
        :label="$t('support.playerId')"
      />
      <l-columns-column
        class="mt-auto"
        size="narrow"
      >
        <a-button
          class="mt-auto"
          variant="primary"
          :text="$t('common.search')"
          :disabled="!inputValid"
        />
      </l-columns-column>
    </l-columns>
  </form>
</template>

<script>
  import CasinoSelect from '@/components/CasinoSelect'
  import { AButton, LColumns, LColumnsColumn, MInput } from 'codefabrik-gui-vue'

  export default {
    name: 'OpenGameRoundListSearchForm',
    components: {
      CasinoSelect, LColumns, MInput, AButton, LColumnsColumn
    },
    data () {
      return {
        input: {
          casinoId: null,
          playerId: null
        }
      }
    },
    computed: {
      inputValid () {
        return this.input.casinoId && this.input.playerId
      }
    },
    methods: {
      handleSubmit () {
        this.$emit('submit', {
          casinoId: this.input.casinoId,
          playerId: this.input.playerId
        })
      }
    },
    watch: {
      'input.casinoId' (newValue, oldValue) {
        this.$emit('casino-select', newValue)
      }
    },
  }
</script>

<style scoped>

</style>
